import styled from "@emotion/styled";

import { NotebookCell } from "../../NotebookCell";

export const DataStepCell = styled.div`
  padding: ${NotebookCell.CONTAINER_PADDING};
`;
